import { render, staticRenderFns } from "./PathNotFound.vue?vue&type=template&id=350b787a&scoped=true&"
import script from "./PathNotFound.vue?vue&type=script&lang=js&"
export * from "./PathNotFound.vue?vue&type=script&lang=js&"
import style0 from "./PathNotFound.vue?vue&type=style&index=0&id=350b787a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b787a",
  null
  
)

export default component.exports